<script setup lang="ts">
import { useStrategy } from '@/domains/esg/composables/content/useStrategy'
const { prioritiesEnvironmental, prioritiesSocial, prioritiesGovernance } = useStrategy()
</script>

<template>
  <UiSection
    id="priorities"
    class="priorities"
    color="white"
  >
    <UiHeader
      position="center"
      :header="$t('strategy.priorities.header')"
    />

    <div class="section__container">
      <div class="priorities__tab priorities__tab--header">
        <div class="priorities__tab-row">
          <div class="priorities__tab-col">
            {{ $t('strategy.priorities.tableHeadings.h1') }}
          </div>

          <div class="priorities__tab-col">
            {{ $t('strategy.priorities.tableHeadings.h2') }}
          </div>

          <div class="priorities__tab-col">
            {{ $t('strategy.priorities.tableHeadings.h3') }}
          </div>
        </div>
      </div>

      <div class="priorities__tab priorities__tab--environmental">
        <div
          v-for="item in prioritiesEnvironmental"
          :key="`esrs-${item.c1}`"
          class="priorities__tab-row"
        >
          <div class="priorities__tab-col">
            <i>{{ item.c1 }}</i>
          </div>

          <div class="priorities__tab-col priorities__tab-col--priority">
            {{ item.c2 }}
          </div>

          <div
            class="priorities__tab-col"
            v-html="item.c3"
          />
        </div>
      </div>

      <div class="priorities__tab priorities__tab--social">
        <div
          v-for="item in prioritiesSocial"
          :key="`esrs-${item.c1}`"
          class="priorities__tab-row"
        >
          <div class="priorities__tab-col">
            <i>{{ item.c1 }}</i>
          </div>

          <div class="priorities__tab-col  priorities__tab-col--priority">
            {{ item.c2 }}
          </div>

          <div
            class="priorities__tab-col"
            v-html="item.c3"
          />
        </div>
      </div>

      <div class="priorities__tab priorities__tab--governance">
        <div
          v-for="item in prioritiesGovernance"
          :key="`esrs-${item.c1}`"
          class="priorities__tab-row"
        >
          <div class="priorities__tab-col">
            <i>{{ item.c1 }}</i>
          </div>

          <div class="priorities__tab-col priorities__tab-col--priority">
            {{ item.c2 }}
          </div>

          <div
            class="priorities__tab-col"
            v-html="item.c3"
          />
        </div>
      </div>
    </div>
  </UiSection>
</template>

<style lang="scss" scoped>
:deep(.ui-header) {
  margin-bottom: 3.2rem;
}

.priorities {

  :deep(.ui-header__header) {
    margin-bottom: 9rem;
  }

  &__tab {
    margin-bottom: 1.6rem;
    border: 1px solid #F6F7F7;
    border-radius: 8px;

    i {
      @include body-2-medium;
      display: inline-block;
      width: 8rem;
      height: 3.2rem;
      text-align: center;
      background-color: $gray-500;
    }

    &--environmental {
      i {
        color: $white;
        background: linear-gradient(90deg, #3B7BF5 0%, #6CA4FA 100%);
      }
    }

    &--social {
      i {
        color: $white;
        background: linear-gradient(90deg, #A265F0 0%, #C39BF5 100%);
      }
    }

    &--governance {
      i {
        color: #065D86;
        background: linear-gradient(90deg, #78CBFA 0%, #B3E2FD 100%);
      }
    }

    &-row {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 1.6rem 0;
      border-bottom: 1px solid #F6F7F7;

      &:last-of-type {
        border-bottom: none;
      }
    }

    &-col {
      @include body-3;
      width: 100%;
      padding: 0.8rem 2rem;

      :deep(ul) {
        margin-left: 1.6rem;
        list-style-type: disc;
      }

      i {
        padding: 0.4rem 1.6rem;
        font-weight: 500;
        border-radius: 3.2rem;
      }

      &--priority {
        font-weight: 700;
        font-size: 1.7rem;
      }
    }

    &--header {
      display: none;
      background-color: #F6F7F7;
      border: none;

      .priorities__tab-row {
        flex-direction: row;
      }

      .priorities__tab-col {
        @include body-1-medium;
        width: auto;
        font-weight: 700;
      }
    }
  }
}

@include atM {
  :deep(.ui-header) {
    margin-bottom: 9rem;
  }

  .priorities {
    &__tab {
      &-row {
        flex-direction: row;
        padding: 0;
      }

      &-col {
        width: 45%;
        padding: 2rem 2.4rem;

        &:first-of-type {
          width: 10%;
        }
      }
      
      &--header {
        display: block;
        
        .priorities__tab-col {
          width: 45%;
          
          &:first-of-type {
            width: 10%;
          }
        }
      }
    }
  }
}
</style>
